import * as R from 'ramda'
import { of } from 'rxjs'
import { distinctUntilKeyChanged, map, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { queryFromString } from 'helpers/url'
import * as Actions from 'store/actions/index.ts'

const getQueryFromPayload = R.pipe(
  R.path(['payload', 'location', 'search']),
  queryFromString
)

const checkoutReset = (action$) => action$.pipe( // Observable<CheckoutResetAction>
  ofType(LOCATION_CHANGE),
  map(getQueryFromPayload),
  distinctUntilKeyChanged('key'),
  switchMap(() => of(Actions.checkout.onCheckoutReset()))
)

export default checkoutReset
